// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___HSgP","textarea":"styles_textarea__2gNFT"};